"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitButton = void 0;
const formik_1 = require("formik");
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const SubmitButton = (props) => {
    const { handleSubmit, errors } = (0, formik_1.useFormikContext)();
    const { disableOnErrors } = props;
    return (react_1.default.createElement(components_1.Button, Object.assign({}, props, { disabled: disableOnErrors && !(0, lodash_1.isEmpty)(errors), type: "submit", onClick: handleSubmit })));
};
exports.SubmitButton = SubmitButton;
